import { PRODUCTS_SAVE, SUBSCRIPTION_SAVE } from '../../constants/actionTypes';

const INITIAL_STATE = {
  products: [],
  subscription: null,
};

const saveProducts = (state, action) => ({
  ...state,
  products: action.products,
});

const saveSubscription = (state, action) => ({
  ...state,
  subscription: action.subscription,
});

const subscriptionReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PRODUCTS_SAVE:
      return saveProducts(state, action);
    case SUBSCRIPTION_SAVE:
      return saveSubscription(state, action);
    default:
      return state;
  }
};

export default subscriptionReducer;
